import firebase from 'firebase'
import vm from '../main'

const internals = {}

internals.updateTrip = (docId, prevDestination, divertedDestination) => {
    var ss = firebase.database().ref(docId + '/').set({
        prev_destination: prevDestination,
        next_destination: divertedDestination,
    });
    console.log("SSSSSS", ss)
}

export default internals


// WEBPACK FOOTER //
// ./src/services/firebase.service.js